import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CurrencyCircleDollar } from "@phosphor-icons/react";

const Item = ({ label, r }) =>
  r ? (
    <div className="flex items-center gap-1.5" data-testid={`rate-${label}`}>
      <span className="text-xs font-bold text-white">{label}</span>
      <span className="text-xs font-semibold tabular-nums text-white">{Number(r.buy).toFixed(2)}</span>
      <span className="text-[10px] text-white/50">/</span>
      <span className="text-xs font-semibold tabular-nums text-white">{Number(r.sale).toFixed(2)}</span>
    </div>
  ) : null;

export default function CurrencyTicker() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchRates = () => api.get("/rates").then((r) => setData(r.data)).catch(() => {});
    fetchRates();
    const id = setInterval(fetchRates, 2 * 60 * 60 * 1000); // 1 раз на 2 години
    return () => clearInterval(id);
  }, []);

  if (!data) return null;
  const get = (ccy) => data.rates.find((r) => r.ccy === ccy);
  const updated = data.updated_at
    ? new Date(data.updated_at).toLocaleString("uk-UA", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })
    : "";

  return (
    <div className="ml-auto flex items-center gap-2" data-testid="currency-ticker"
      title={`Курс ${data.source} (${data.city}) · оновлено ${updated} · купівля/продаж ₴`}>
      <span className="hidden md:inline text-xs text-white/70">Львів · ₴</span>
      <div className="flex items-center gap-3 sm:gap-4 px-3 py-1.5 rounded-full bg-white/10 border border-white/20">
        <CurrencyCircleDollar size={16} className="text-white/70 hidden sm:block" />
        <Item label="USD" r={get("USD")} />
        <Item label="EUR" r={get("EUR")} />
      </div>
    </div>
  );
}
